import store from '@/redux/store'
import { FC, ReactNode } from 'react'
import { Provider } from 'react-redux'

interface AppProvidersProps {
    children: ReactNode
}

const AppProviders: FC<AppProvidersProps> = ({ children }) => {
    return <Provider store={store}>{children}</Provider>
}

export default AppProviders
